// extracted by mini-css-extract-plugin
export var companyInfo = "footer-module--company-info--d6c57";
export var footer = "footer-module--footer--64f26";
export var footerContent = "footer-module--footer-content--4df65";
export var footerHeading = "footer-module--footer-heading--0586e";
export var spacer = "footer-module--spacer--50ded";
export var tag = "footer-module--tag--04fff";